import { doc, getDoc, addDoc, collection, serverTimestamp } from "firebase/firestore";
import { db } from "../firebase";

export async function getDictionaryEntry({ lemma, pos }) {
  const key = `${lemma}_${pos}`;
  const ref = doc(db, "deupor", key);
  const snap = await getDoc(ref);
  return snap.exists() ? snap.data() : null;
}

export async function getDictionaryEntryWithFallback({ lemma, pos }) {
  if (!lemma) throw new Error("getDictionaryEntryWithFallback: lemma is required");
  if (!pos) throw new Error("getDictionaryEntryWithFallback: pos is required");

  const POS_LIST = ["adjective", "verb", "noun", "adv", "pron", "prep", "conj", "particle"];

  // try requested pos first
  const first = await getDictionaryEntry({ lemma, pos });
  if (first) return first;

  // try other POS
  for (const altPos of POS_LIST) {
    if (altPos === pos) continue;
    const entry = await getDictionaryEntry({ lemma, pos: altPos });
    if (entry) return entry;
  }

  return null;
}

export async function submitReport({
    uid,
    reason,
    details,
    source,     // e.g. "story-sidebar" | "flashcard"
    payload,    // object with extra fields
  }) {
    if (!uid) throw new Error("submitReport: uid is required");
    if (!reason) throw new Error("submitReport: reason is required");
  
    await addDoc(collection(db, "reports"), {
      userId: uid,
      reason,
      details: details ?? "",
      source: source ?? null,
      ...(payload ?? {}),
      timestamp: serverTimestamp(),
    });
  }
